"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UploadBar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _ErrorOutlineRounded = _interopRequireDefault(require("@material-ui/icons/ErrorOutlineRounded"));

var _ProgressBar = require("../progress_bar/ProgressBar");

var _Button = require("../button/Button");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: 400,
      borderRadius: '8px 8px 0 0',
      position: 'fixed',
      bottom: '0',
      right: '64px',
      zIndex: 1000
    },
    expand: {
      transform: 'rotate(180deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    expandOpen: {
      transform: 'rotate(0deg)'
    },
    secondaryButton: {
      color: theme.palette.text.secondary
    },
    primaryButton: {
      color: theme.palette.primary.main
    },
    wrappedButton: {
      justifyContent: 'flex-end',
      padding: '8px 13px 8px 24px',
      borderTop: '1px solid',
      borderTopColor: theme.palette.divider
    },
    topBar: {
      padding: '4px 12px 4px 24px',
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.divider
    },
    wrappedProgressBar: {
      flexDirection: 'column'
    },
    contentText: {
      padding: '8px 0 8px 0',
      color: theme.palette.text.secondary
    },
    content: {
      maxHeight: 255,
      overflow: 'auto',
      padding: '8px 24px 0 24px'
    },
    iconError: {
      color: theme.palette.error.light
    },
    errorSecondaryText: {
      color: theme.palette.text.secondary,
      position: 'relative',
      flexGrow: '1',
      flexShrink: '1',
      flexBasis: '0%',
      fontSize: '14px'
    },
    errorPrimaryText: {
      color: theme.palette.text.main
    },
    listItem: {
      padding: 0,
      width: 'auto'
    }
  };
});

var UploadBar = function UploadBar(_ref) {
  var errorsList = _ref.errorsList,
      totalUploadFiles = _ref.totalUploadFiles,
      progressFileUpload = _ref.progressFileUpload,
      handleCancelUpload = _ref.handleCancelUpload,
      handleCloseUpload = _ref.handleCloseUpload,
      reloadErrorsUpload = _ref.reloadErrorsUpload,
      uploadMessage = _ref.uploadMessage,
      uploadInProgressMessage = _ref.uploadInProgressMessage,
      errorMessage = _ref.errorMessage;
  var classes = useStyles();

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      progress = _useState4[0],
      setProgress = _useState4[1];

  var handleExpandClick = function handleExpandClick() {
    setExpanded(!expanded);
  };

  (0, _react.useEffect)(function () {
    var uploadEvolution = 100 * progressFileUpload / totalUploadFiles;
    setProgress(uploadEvolution);
  }, [progress, progressFileUpload, totalUploadFiles]);

  var errorsUpload = /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    className: classes.content,
    variant: "scrollable"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.errorPrimaryText,
    variant: "body2"
  }, ' ', errorMessage.replace('{count}', errorsList.length)), /*#__PURE__*/_react.default.createElement(_core.List, null, errorsList.map(function (value) {
    return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
      className: classes.listItem
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.errorSecondaryText,
      variant: "body2"
    }, ' ', value, ' '), /*#__PURE__*/_react.default.createElement(_ErrorOutlineRounded.default, {
      className: classes.iconError
    }));
  })));

  var progressUpload = /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    className: classes.content
  }, progress < 100 ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.contentText,
    variant: "body2"
  }, uploadMessage) : /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentText
  }), /*#__PURE__*/_react.default.createElement(_core.CardActions, {
    className: classes.wrappedProgressBar
  }, /*#__PURE__*/_react.default.createElement(_ProgressBar.ProgressBar, {
    color: "primary",
    value: progress,
    size: "full"
  }), progress === 100 ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.contentText,
    variant: "body2"
  }, "Upload finalizado com sucesso!") : /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.contentText,
    variant: "body2"
  }, uploadInProgressMessage || "Arquivo ".concat(progressFileUpload, " de ").concat(totalUploadFiles))));

  var cancelButton = /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: classes.secondaryButton,
    color: "secondary",
    onClick: handleCancelUpload
  }, "CANCELAR");

  var closeButton = /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: classes.primaryButton,
    color: "primary",
    onClick: handleCloseUpload
  }, "FECHAR");

  var reloadButton = /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: classes.primaryButton,
    color: "primary",
    onClick: reloadErrorsUpload
  }, "RECARREGAR");

  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.CardActions, {
    disableSpacing: true,
    className: classes.topBar
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, "Upload"), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: (0, _clsx2.default)(classes.expand, _defineProperty({}, classes.expandOpen, expanded)),
    onClick: handleExpandClick,
    "aria-expanded": expanded,
    "aria-label": "show more"
  }, /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null))), /*#__PURE__*/_react.default.createElement(_core.Collapse, {
    in: expanded,
    timeout: "auto",
    unmountOnExit: true
  }, errorsList.length !== 0 && progress === 100 ? errorsUpload : progressUpload, /*#__PURE__*/_react.default.createElement(_core.CardActions, {
    className: classes.wrappedButton
  }, progress < 100 ? cancelButton : null, errorsList.length !== 0 && progress === 100 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, cancelButton, reloadButton) : null, errorsList.length === 0 && progress === 100 ? closeButton : null)));
};

exports.UploadBar = UploadBar;
UploadBar.propTypes = {
  /**
   * Quantidade de arquivos em que o upload já foi realizado
   */
  progressFileUpload: _propTypes.default.number.isRequired,

  /**
   * Quantidade total de arquivos para upload
   */
  totalUploadFiles: _propTypes.default.number.isRequired,

  /**
   *  Lista de erros do upload
   */
  errorsList: _propTypes.default.arrayOf(_propTypes.default.string.isRequired),

  /**
   *  Função que será executada quando o botão `Cancelar` for clicado
   */
  handleCancelUpload: _propTypes.default.func.isRequired,

  /**
   *  Função que será executada quando o botão `Fechar` for clicado
   */
  handleCloseUpload: _propTypes.default.func.isRequired,

  /**
   *  Função que será executada quando o botão `Recarregar` for clicado
   */
  reloadErrorsUpload: _propTypes.default.func.isRequired,

  /**
   *  Função para alterar o texto de upload
   */
  uploadMessage: _propTypes.default.string,

  /**
   *  Mensagem exibida quando o upload estiver em andamento (opcional)
   */
  uploadInProgressMessage: _propTypes.default.string,

  /**
  * 
  Mensagem personalizada para erros de upload
  */
  errorMessage: _propTypes.default.string
};
UploadBar.defaultProps = {
  errorsList: [],
  uploadMessage: 'Espere o upload finalizar para continuar',
  errorMessage: 'Arquivos tiveram problemas ao fazer o upload'
};
var _default = UploadBar;
exports.default = _default;